import i18n from "@/langs";
import { getLang } from "@/utils/langs";
// const files = require.context("./modules", false, /[^privacy_policy]\.js/);
let files = [];
if (process.env.VUE_APP_REGION === "komoe") {
  files = require.context(
    "./modules",
    false,
    /^((?!\.\/privacy_policy).)*\.js$/
  );
} else {
  files = require.context("./modules", false, /\.js/);
}

//注入路由
let configRouters = [];
files.keys().forEach((key) => {
  // jp 没有支付模块
  if (
    process.env.VUE_APP_REGION === "jp" &&
    (key === "./paygame.js" || key === "./pay_h5.js" || key === "./pays_h5.js")
  ) {
    return false;
  }
  // komoe 没有隐私条款模块
  if (
    process.env.VUE_APP_REGION === "komoe" &&
    (key === "./privacy_policy.js" || key === "./tokusyouhou.js")
  ) {
    return false;
  }
  // komoe东南亚 没有注册，新闻，活动
  if (
    process.env.VUE_APP_REGION === "komoe" &&
    process.env.VUE_APP_AREA === "komoe-sea"
  ) {
    if (
      key === "./signup.js" ||
      key === "./signup_h5.js" ||
      key === "./news.js" ||
      key === "./active.js"
    ) {
      return false;
    }
  }
  if (files(key).default) {
    configRouters = [
      ...configRouters,
      ...files(key).default(i18n.messages[getLang()]),
    ];
  }
});
export default configRouters;
